import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { FormattedHTMLMessage, useIntl } from "react-intl";
import { getEndSeconds, getStartSeconds } from "../../../../../../../common/parameters";
import { post } from "../../../../../../actions/general";
import { editTask } from "../../../../../../store/plan/actions";
import ScoreVideoSlide from "../../ScoreVideoSlide";
import youtubeApi from "../../youtubeApi";

import { IProps } from "./interfaces";
import { Container, IframeWrapper, Controls, StartVideoText, RecButton, ResetButton, Directions, Buttons, Completed } from "./styles";
import messages from "./messages";

const ScoreVideoSync = ({ data, plan, taskIndex }: IProps) => {
    const dispatch = useDispatch();
    const { formatMessage } = useIntl();
    const domId = useRef("player_" + Date.now()).current;
    const [isPlaying, setIsPlaying] = useState(false);
    const player = useRef<any>(null);
    const [points, setPoints] = useState(data.points || []);
    const _points = useRef(points);
    _points.current = points;
    const onPlayerStateChange = ({ data: state }: { data: number }) => {
        if (state === 1 && _points.current.length === 0) {
            setIsPlaying(true);
            (document.activeElement as HTMLIFrameElement).blur()
        } else {
            setIsPlaying(false);
        }
        if (state !== 1 && _points.current.length > 0) {
            dispatch(post("subscore-points", { points: _points.current, planId: plan._id, taskIndex }, () => {
                dispatch(editTask({
                    taskIndex,
                    changingProp: "points",
                    val: _points.current,
                }))
            }))
        }
    }

    const recordKeydown = (e: KeyboardEvent) => {
        if (!isPlaying || e.key.toLowerCase() !== "j") {
            return;
        }
        handleRecordPoint();
    };

    useEffect(() => {
        window.addEventListener("keydown", recordKeydown);
        return () => {
            window.removeEventListener("keydown", recordKeydown);
        }
    })
    const setupVideo = () => {
        if (!data.href) return;
        if (!window.YT || !window.YT.Player || !document.getElementById(domId)) {
            setTimeout(setupVideo, 50);
            return;
        }
        if (player.current) {
            player.current.destroy();
        }
        player.current = new window.YT.Player(domId, {
            height: 668,
            width: 900,
            videoId: data.href,
            playerVars: {
                playsinline: 1,
                disablekb: 1,
                fs: 0,
                start: getStartSeconds(data),
                end: getEndSeconds(data),
            },
            events: {
                // 'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        });
    }
    useEffect(() => {
        youtubeApi();
        setTimeout(setupVideo, 50);
    }, []);

    const handleRecordPoint = () => {
        const time = Number((player.current!.getCurrentTime() as number).toFixed(2));
        setPoints(old => [...old, time]);
    }
    const handleResetPoints = () => {
        setPoints([]);
        dispatch(post("subscore-points", { points: [], planId: plan._id, taskIndex }, () => {
            dispatch(editTask({
                taskIndex,
                changingProp: "points",
                val: [],
            }))
        }))
    }
    if (!data.href) return null;   
    
    return (
        <Container>
            <IframeWrapper>
                <ScoreVideoSlide scores={data.scores} currentPoint={points.length} width={900} opacity={data.opacity || 0.5}/>
                <div id={domId} />
            </IframeWrapper>
            <Controls>
                <Buttons>
                    {!isPlaying && points.length === 0 && (
                        <StartVideoText>
                            {formatMessage(messages.start)}
                        </StartVideoText>
                    )}
                    {isPlaying && (
                        <RecButton onMouseDown={handleRecordPoint}>
                            J
                        </RecButton>
                    )}
                    {!isPlaying && points.length > 0 && (
                        <ResetButton className="button" onClick={handleResetPoints}>
                            {formatMessage(messages.redo)}
                        </ResetButton>
                    )}
                    {!isPlaying && points.length > 0 && (
                        <Completed>
                            {formatMessage(messages.completed)}
                        </Completed>
                    )}
                </Buttons>
                <Directions>
                    <FormattedHTMLMessage {...messages.tutorial} />
                </Directions>
            </Controls>
        </Container>
    );
};

export default ScoreVideoSync;
